import http from '../../services/http-common';

class UploadPIService {
  uploadPIData(data) {
    return http.post('/UploadExcelPI/upload',data);
  }
  
}

export default new UploadPIService();
